export const formatBoolAsYN = (value: boolean | null | undefined): string => {
    return value === true ? 'Y' : 'N';
};
